import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-trip-route',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
        <div class="flex justify-between items-center gap-x-2">
            <div class="flex items-center gap-x-2 min-w-0 w-full" [ngClass]="textSize">
                <ng-container *ngFor="let location of locationData; let first = first; let i = index; let last = last; let even = even">
                <!-- [ngClass]="{'text-danger': isIncident && !first, 'text-gray-700': !isIncident}" -->
                <span class="flex items-center font-medium min-w-0 max-w-[100%]">
                    <i nz-icon [nzType]="location?.type === 'leg' ? 'environment' : 'flag'" class="text-blue-500 mr-1"></i>
                    <span
                        class="truncate block max-w-full"
                        [title]="location?.location">
                        {{ location?.location || '-' }}
                    </span>
                </span>
                <span nz-icon nzType="minus" *ngIf="legCount && !last" class="text-sm" [ngClass]="{'text-danger': isIncident, 'text-gray-400': !isIncident}"></span>
                <nz-badge *ngIf="legCount && !last" nzStandalone nzShowZero [nzCount]="legCount" [nzStyle]="{'backgroundColor': isIncident ? '#dc2626' : '#9ca3af'}"/>
                <span *ngIf="!last" class="text-sm flex-shrink-0" [ngClass]="{'text-danger': isIncident, 'text-gray-400': !isIncident}">
                    <i nz-icon nzType="arrow-right" nzTheme="outline"></i>
                </span>
                </ng-container>
            </div>
        </div>
  `,
  styles: ``
})
export class TripRouteComponent {
    @Input({ required: true }) locationData: { location: string, type: 'leg' | 'last-leg', legCount?: string }[] = [];
    @Input({ required: false, alias: 'legCount'}) legCount: number = 0;
    @Input({ required: false, alias: 'isIncident'}) isIncident: boolean = false;
    @Input({ required: false, alias: 'textSize' }) textSize: 'text-base'| 'text-xs' | 'text-sm' | 'text-md' | 'text-lg' = 'text-sm';
}
